import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';

function VerifyEmailPage() {
  const navigate = useNavigate();
  const [email] = useState('');

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 relative">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-cyan-400/10 rounded-2xl blur-3xl" />
        <div className="absolute inset-0 bg-slate-900/80 rounded-2xl backdrop-blur-sm" />

        <div className="relative bg-slate-900/50 p-8 rounded-2xl border border-slate-800 shadow-2xl">
          <div className="text-center mb-8">
            <div className="mx-auto w-16 h-16 bg-cyan-400/20 rounded-full flex items-center justify-center mb-4">
              <Mail className="w-8 h-8 text-cyan-400" />
            </div>
            <h2 className="text-3xl font-bold bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent">
              Verify Your Email
            </h2>
            <p className="mt-2 text-gray-400">We&apos;ve sent a verification link to</p>
            <p className="text-cyan-400 font-medium">{email}</p>
          </div>

          <div className="space-y-4">
            <p className="text-gray-400 text-sm text-center">
              Click the link in your email to verify your account. If you don&apos;t see it, check your spam folder.
            </p>

            <div className="text-center">
              <button
                type="button"
                onClick={() => navigate('/login')}
                className="text-sm text-cyan-400 hover:text-cyan-300"
              >
                Back to login
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyEmailPage;
